import React, { lazy } from 'react';
import { motion } from 'framer-motion';
interface ImageFadeInProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}
export const ImageFadeIn = ({
  src,
  alt,
  className = '',
  style
}: ImageFadeInProps) => {
  return <motion.img src={src} alt={alt} className={className} style={style} initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} loading="lazy" data-id="element-54" />;
};